/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../../helper/currencyFormatter";
import { formatNumber } from "../../../../helper/numberFormatter";
import formatDate from "../../../../helper/dateFormatter";

const SettlementTable = (props) => {
  const t = props.t;
  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "DATA_MB") {
      return "MB";
    } else if (val === "DATA_GB") {
      return "GB";
    } else {
      return "";
    }
  };
  return (
    <div className={classes.root}>
      <TableContainer>
        {/* <Table className={classes.table} aria-label="simple table"> */}
        <Table
          className={"newGlobalTable"}
          aria-label="simple table"
          style={{ background: "white" }}
        >
          <TableHead>
            <TableRow>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("settlementToPartyName");
                  }}
                >
                  <b>{t("SOLUTION_PROVIDER_NAME")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "settlementToPartyName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("providerPackageSolutionName");
                  }}
                >
                  <b>{t("SOLUTION_NAME")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "providerPackageSolutionName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("providerProductName");
                }}
              >
                <b>{t("PRODUCT_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "providerProductName" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("orderId");
                }}
              >
                <b>{t("ORDER_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "orderId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("customerName");
                }}
              >
                <b>{t("CUSTOMER_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "customerName" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {props.providerType === "SOLUTION_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("settlementFromPartyName");
                  }}
                >
                  <b>{t("PARTY_NAME")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "settlementFromPartyName" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("customerBan");
                  }}
                >
                  <b>{t("CUSTOMER_BAN")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "customerBan" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("quantity");
                }}
              >
                <b>{t("QUANTITY")}</b>
                {/* Sort indication */}
                {props.sortBy === "quantity" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" && (
                <TableCell
                  className="global-custom-sorting-header"
                  onClick={(e) => {
                    props.updateSorting("amountSold");
                  }}
                >
                  <b>{t("AMOUNT_SOLD")}</b>
                  {/* Sort indication */}
                  {props.sortBy === "amountSold" ? (
                    <span className="material-icons">
                      {props.sortOrder === "DESC"
                        ? "expand_less"
                        : "expand_more"}
                    </span>
                  ) : (
                    <span className="material-icons sorting-indicator-icon">
                      unfold_more
                    </span>
                  )}
                </TableCell>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("amountSettled");
                }}
              >
                <b>{t("AMOUNT_SETTLED")}</b>
                {/* Sort indication */}
                {props.sortBy === "amountSettled" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                !props.tenantRoles.includes("MASTER_PROVIDER") && (
                  <TableCell>
                    <b>{t("THIRD_PARTY_COST")}</b>
                  </TableCell>
                )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("priceType");
                }}
              >
                <b>{t("PRICE_TYPE")}</b>
                {/* Sort indication */}
                {props.sortBy === "amountSettled" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("billingDate");
                }}
                align="right"
              >
                {/* Sort indication */}
                {props.sortBy === "billingDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
                <b>{t("DATE")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show settlements list */}
            {props.list.map((row, index) => (
              <TableRow
                key={index}
                style={{ cursor: "default" }}
                className={classes.rowClass}
              >
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{row.settlementToPartyName}</TableCell>
                )}
                {props.providerType === "SALES_CHNL_PROVIDER" ? (
                  <>
                    <TableCell>{row.sellerPackageSolutionName}</TableCell>
                    <TableCell>{row.sellerProductName}</TableCell>
                  </>
                ) : (
                  <>
                    {/* <TableCell>{row.providerPackageSolutionName}</TableCell> */}
                    <TableCell>{row.providerProductName}</TableCell>
                  </>
                )}
                <TableCell>{row.orderId}</TableCell>
                <TableCell>{row.customerName}</TableCell>
                {props.providerType === "SOLUTION_PROVIDER" && (
                  <TableCell>{row.settlementFromPartyName}</TableCell>
                )}
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{row.customerBan}</TableCell>
                )}
                <TableCell>{row.quantity}</TableCell>
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <TableCell>{currencyFormatter(row.amountSold)}</TableCell>
                )}
                <TableCell>
                  {row.amountSettled
                    ? currencyFormatter(row.amountSettled)
                    : currencyFormatter("", false) + " 0.00"}
                </TableCell>
                {props.providerType === "SALES_CHNL_PROVIDER" &&
                  !props.tenantRoles.includes("MASTER_PROVIDER") && (
                    <TableCell>
                      {row.thirdPartyPrice
                        ? currencyFormatter(row.thirdPartyPrice)
                        : currencyFormatter("", false) + " 0.00"}
                    </TableCell>
                  )}
                {/* <TableCell>{row.priceType ? row.priceType === 'PURCHASE' ? t('NRC_FULL') : t(row.priceType) : ''}</TableCell> */}
                <TableCell>
                  {row.priceType &&
                    (row.priceType === "RECURRING_CHARGE"
                      ? row.termAmount && row.termUomId
                        ? row.termAmount > 1
                          ? `${t(row.priceType)} (${row.termAmount} ${getPriceTenureUOM(row.termUomId)})`
                          : `${t(row.priceType)} (per ${getPriceTenureUOM(row.termUomId)})`
                        : t(row.priceType)
                      : row.priceType === "PURCHASE"
                        ? t("NON_RECURRING_CHARGE")
                        : t(row.priceType))}
                </TableCell>
                <TableCell align="right">
                  {/* {props.convertDate(row.billingDate)} */}
                  {formatDate(row.billingDate)}
                </TableCell>
              </TableRow>
            ))}
            {/* If there is no settlements to show */}
            {props.list.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  {t("NO_SETTLEMENT_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalSettlementCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(props.totalSettlementCount)}
          </label>
          <label>
            {t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          <Pagination
            count={Math.ceil(props.totalSettlementCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(SettlementTable);
